import { render, staticRenderFns } from "./Composers.vue?vue&type=template&id=ff11c080&"
import script from "./Composers.vue?vue&type=script&lang=js&"
export * from "./Composers.vue?vue&type=script&lang=js&"
import style0 from "./Composers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports